export default {
  backgroundColor: "#c9def6",
};